<template>
  <div id="app">
    <Header
      v-if="$route.meta.showLogin != true"
      ref="header"
      style="z-index: 5"
    />
    <router-view></router-view>
    <Footer v-if="$route.meta.showLogin2 != true" />
  </div>
</template>
<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
export default {
  name: "",
  components: {
    Header,
    Footer,
  },
};
</script>

<style>
@import "./assets/css/free.css";
body {
  margin: 0;
}
</style>
